export default "__VITE_PUBLIC_ASSET__4d691a01__"